import NotificationsContainer from "./container";

export default NotificationsContainer;
